import { createContext } from 'react';

import { SearchState } from './types';

export const SearchContext = createContext<SearchState | undefined>(undefined);
